import { useContext, useEffect, useRef, useState } from "react";

import { ANSWER, QUESTIONS } from "../../api/Api";
import { handleMaxInputLines } from "../HelpFullFunction";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useStore from "../../Store/useStore";
import { useAuth } from "../../context/AuthContext";
import { UserContext } from "../../context/UserContext";
import { Link } from "react-router-dom";
import { useOpenField } from "../../Store/MenuSlice";
import { authAxios } from "../../Axios/createAxios";
export default function AnswerForm() {
  const [answer, setAnswer] = useState("");

  const questionId = useStore((state) => state.questionId);
  const textareaRef = useRef(null);
  const queryClient = useQueryClient();
  const { isAuth } = useAuth();
  const openField = useOpenField();
  const { userInfo } = useContext(UserContext);
  const data = async () => {
    try {
      const res = authAxios.post(`/${QUESTIONS}/${questionId}/${ANSWER}`, { answer });
      return res;
    } catch (e) {
      throw e;
    }
  };
  const { mutate, isLoading, isPaused, isIdle } = useMutation({
    mutationFn: data,
    onMutate: () => {},
    onSuccess: () => {
      queryClient.invalidateQueries("answers");
      setAnswer("");
    },
    onError: (e) => {
      console.log(e);
    },
  });

  console.log(!!isAuth, "is it and verified");
  console.log(!!userInfo?.email_verified_at && !!isAuth && !!questionId);
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [answer]);
  const onSub = (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (answer.length < 15) return;
    if (userInfo?.email_verified_at === null) {
      openField("isVerified");
      return;
    }
    if (!isAuth) return;

    mutate();
  };
  const form = () => {
    return (
      <form onSubmit={onSub} className="relative answer-form radius-5 p-10">
        <textarea
          onInput={handleMaxInputLines}
          ref={textareaRef}
          value={answer}
          name="answer"
          maxLength={"150"}
          onChange={(e) => {
            setAnswer(e.target.value);
          }}
          placeholder="You are what you write"
          rows={"1"}></textarea>
        <button type="submit" className={`${answer.length < 15 || isLoading ? "opacity-5 defualt-cursor " : ""}`}>
          {isLoading ? (
            <i className="fa-solid fa-spinner rotating-element"></i>
          ) : (
            <i className="fa-solid fa-arrow-up"></i>
          )}
        </button>
      </form>
    );
  };
  return (
    <>
      {!isAuth ? (
        <div className="d-flex  flex-around relative prime-c sec-bg-c radius-5 p-10">
          <Link className="prime-c" to={"/login"}>
            Log in
          </Link>
          <Link className="prime-c" to={"/register"}>
            Sign Up
          </Link>
        </div>
      ) : (
        form()
      )}
    </>
  );
}
